export const FINANCIACION_BANNER =
  'https://cdn.magicpatterns.com/uploads/wrwnJBFFMBY3eEwYQGZoH7/heylloyd-image-1787679637095.png'

/** Placa de presentación de la marca: primer bloque de la home. */
export const VCARS_BANNER =
  'https://cdn.magicpatterns.com/uploads/jyRQjdBNaHu7bU6Tq2Rrn3/heylloyd-image-1786928526004.png'

/** Catálogo oficial de VCARS (sitio externo). Todos los botones "Catálogo" llevan acá. */
export const CATALOGO_URL = 'https://catalogo.automotoresvcars.com'

export const VCARS_LOGO =
  'https://cdn.magicpatterns.com/uploads/rDK1faMXrKG756QEZowWq1/WhatsApp_Image_2026-08-19_at_10.47.44_PM.jpg'

export const CONTACTO = {
  ventasNombre: 'Leonel',
  ventasTelefono: '11 5644-9518',
  ventasWhatsapp: '5491156449518',
  adminTelefono: '11 2468-7787',
  adminWhatsapp: '5491124687787',
  email: 'automotoresvcars@gmail.com',
  ubicacion: 'Zona Oeste, Buenos Aires y alrededores',
  instagram: 'https://www.instagram.com/v.carss_/',
  instagramUsuario: '@v.carss_',
}
